import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import CheckBox from 'yoda-core-components/lib/components/CheckBox';
import PropTypes from 'prop-types';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import SlidePanel from 'yoda-account-components/lib/components/SlidePanel/SlidePanel';
import { Link } from 'react-router-dom';
import * as styles from './PromoSMSEmailWrapper.css';
import PromoSMSEmailForm from './PromoSMSEmailForm';

const cx = classNames.bind(styles);

export default function PromoSMSEmailWrapper({
    preferences,
    messagesTexts,
    featureFlags,
    actions,
    accountDetails,
    promotionalSignUpContent,
}) {
    const [showPromoTerms, toggleShowPromoTerms] = useState(false);
    const [isPromoChecked, togglePromoAgreement] = useState(true);
    /* istanbul ignore next */
    useEffect(() => {
        const { getPromotionalSignUpContentAction, camAnalyticsAction } = actions;
        const { promotionalData, error } = promotionalSignUpContent;
        const { enablePromotionalSignUpMigrationToCM = true } = featureFlags;
        // If no data or any error from server side
        /* istanbul ignore next */
        if ((isEmpty(promotionalData) || !isEmpty(error)) && enablePromotionalSignUpMigrationToCM) {
            /* istanbul ignore next */
            getPromotionalSignUpContentAction();
        }
        /* set digitalData on promotional signup page load success */
        const analyticsData = {
            trackEvent: 'digitalDataReady',
            pageName: 'promotional signup page',
        };
        camAnalyticsAction(analyticsData);
    }, []);

    return (
        <Layout>
            <div
                className={`${cx('promoSMSEmailWrapper', 'tailwindGrid')} ${dt([
                    'text-center',
                    'mt-6',
                    'mb-10',
                ])}`}
            >
                <span
                    className={dt(['sm12', 'md12', 'lg8', '!p-0', 'mdOnly:!px-6'])}
                    data-automation-id="at-promo-image-section"
                    // eslint-disable-next-line react/no-danger, react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: promotionalSignUpContent?.imageSection,
                    }}
                />
                <div data-automation-id="at-promo-right-section" className={dt(['smMd:px-6'])}>
                    <div className={dt(['sm12', 'md12', 'lg6', '!p-0', 'lg:!w-[454px]'])}>
                        <p
                            className={dt([
                                'text-xlarge',
                                'font-semibold',
                                'mt-6',
                                'text-left',
                                'text-black',
                            ])}
                            data-automation-id="at-promo-header"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: promotionalSignUpContent?.headerSection,
                            }}
                        />
                        <p
                            className={dt([
                                'text-normal',
                                'sm:mt-2',
                                'mb-6',
                                'text-left',
                                'text-black',
                            ])}
                            data-automation-id="at-promo-subtitle"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: promotionalSignUpContent?.subTitleSection,
                            }}
                        />
                        {/* istanbul ignore next */}
                        <PromoSMSEmailForm
                            preferences={preferences}
                            messagesTexts={messagesTexts}
                            featureFlags={featureFlags}
                            actions={actions}
                            accountDetails={accountDetails}
                            isPromoChecked={isPromoChecked}
                        />
                        <CheckBox
                            className={dt(['w-full', 'mb-6'])}
                            id="textMessage"
                            checked={isPromoChecked}
                            size="Sm"
                            automationId="at-promo-agree"
                            onChange={() => togglePromoAgreement(!isPromoChecked)}
                            label={
                                <p
                                    className={`${dt(['text-left', 'text-black'])} ${cx(
                                        'promo-checkbox-label'
                                    )}`}
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                        __html: promotionalSignUpContent?.agreementSection,
                                    }}
                                />
                            }
                        />

                        <p className={dt(['text-xsmall', 'text-left', 'text-black'])}>
                            *Terms Apply{' '}
                            <span
                                data-automation-id="promotionalsms-terms-btn"
                                onClick={() => toggleShowPromoTerms(true)}
                                className={dt(['underline', 'cursor-pointer', 'pl-2', 'pr-2'])}
                            >
                                See Details
                            </span>{' '}
                            <Link
                                className={dt(['underline'])}
                                to="/m/privacy-notice"
                                target="_blank"
                            >
                                View Privacy Notice
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
            <SlidePanel
                panelTitle="Promotional Terms & Conditions"
                isOpenPanel={showPromoTerms}
                onPrimaryCloseButtonClick={() => toggleShowPromoTerms(false)}
                isPrimaryCloseButtonRequired
                showBackIcon={false}
            >
                <div
                    className={dt(['px-6', 'py-4', 'text-black'])}
                    data-automation-id="at-promo-terms-section"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: promotionalSignUpContent?.TermsSection,
                    }}
                />
            </SlidePanel>
        </Layout>
    );
}

PromoSMSEmailWrapper.propTypes = {
    messagesTexts: PropTypes.string,
    preferences: PropTypes.object,
    actions: PropTypes.func.isRequired,
    featureFlags: PropTypes.object,
    promotionalSignUpContent: PropTypes.object,
    accountDetails: PropTypes.object,
};

PromoSMSEmailWrapper.defaultProps = {
    messagesTexts: {},
    preferences: {},
    featureFlags: {},
    promotionalSignUpContent: {},
    accountDetails: {},
};
